<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M155.302 158.752C165.171 158.752 173.171 150.752 173.171 140.883C173.171 131.015 165.171 123.014 155.302 123.014C145.434 123.014 137.434 131.015 137.434 140.883C137.434 150.752 145.434 158.752 155.302 158.752Z"
      class="fill-secondary-500"
    />
    <path
      d="M122.163 136.294C132.032 136.294 140.032 128.294 140.032 118.426C140.032 108.557 132.032 100.557 122.163 100.557C112.295 100.557 104.294 108.557 104.294 118.426C104.294 128.294 112.295 136.294 122.163 136.294Z"
      class="fill-secondary-500"
    />
    <path
      d="M155.302 123.29C165.171 123.29 173.171 115.289 173.171 105.421C173.171 95.5521 165.171 87.552 155.302 87.552C145.434 87.552 137.434 95.5521 137.434 105.421C137.434 115.289 145.434 123.29 155.302 123.29Z"
      class="fill-brand-100"
    />
    <path
      d="M133.133 65.696C143.002 65.696 151.002 57.6958 151.002 47.8272C151.002 37.9585 143.002 29.9584 133.133 29.9584C123.264 29.9584 115.264 37.9585 115.264 47.8272C115.264 57.6958 123.264 65.696 133.133 65.696Z"
      class="fill-brand-300"
    />
    <path
      d="M92.736 40.8576C102.605 40.8576 110.605 32.8575 110.605 22.9888C110.605 13.1201 102.605 5.12 92.736 5.12C82.8673 5.12 74.8672 13.1201 74.8672 22.9888C74.8672 32.8575 82.8673 40.8576 92.736 40.8576Z"
      class="fill-secondary-500"
    />
    <path
      d="M160.864 88.1471C170.733 88.1471 178.733 80.147 178.733 70.2783C178.733 60.4097 170.733 52.4095 160.864 52.4095C150.995 52.4095 142.995 60.4097 142.995 70.2783C142.995 80.147 150.995 88.1471 160.864 88.1471Z"
      class="fill-brand-300"
    />
    <path
      d="M168.646 134.79H139.808C140.768 132.966 141.312 130.899 141.312 128.698C141.312 121.453 135.437 115.578 128.192 115.578C120.947 115.578 115.072 121.453 115.072 128.698C115.072 130.899 115.622 132.973 116.576 134.79H87.7376C77.216 134.79 68.6848 143.322 68.6848 153.843V191.136C68.6848 201.658 77.216 210.189 87.7376 210.189H168.646C179.168 210.189 187.699 201.658 187.699 191.136V153.843C187.699 143.322 179.168 134.79 168.646 134.79Z"
      class="fill-brand-500"
    />
    <path
      d="M127.552 100.966C137.421 100.966 145.421 92.9662 145.421 83.0976C145.421 73.2289 137.421 65.2288 127.552 65.2288C117.683 65.2288 109.683 73.2289 109.683 83.0976C109.683 92.9662 117.683 100.966 127.552 100.966Z"
      class="fill-secondary-500"
    />
    <path
      d="M94.5408 114.291C104.409 114.291 112.41 106.291 112.41 96.4224C112.41 86.5537 104.409 78.5536 94.5408 78.5536C84.6721 78.5536 76.672 86.5537 76.672 96.4224C76.672 106.291 84.6721 114.291 94.5408 114.291Z"
      class="fill-brand-100"
    />
    <path
      d="M179.872 168.506V157.21C179.872 149.37 173.517 143.008 165.67 143.008H90.7136C82.8736 143.008 76.512 149.363 76.512 157.21V168.506C62.5088 181.67 53.76 200.365 53.76 221.101C53.76 237.683 67.2064 251.13 83.7888 251.13H172.595C189.178 251.13 202.624 237.683 202.624 221.101C202.624 200.365 193.875 181.67 179.872 168.506Z"
      class="fill-brand-300"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Payout'
  }
</script>
